import { sendRequest } from 'utils/utils'
import { tenantUrls, TenantUrlPickOptions } from 'utils/api/storefrontUrls'

export const webFlowAddress = {
	getBranchesList: async ({
		formatted,
		lat,
		lng,
		chainId,
		lang,
		orderType,
		showLoader = true,
	}: {
		formatted?: string
		lat?: number
		lng?: number
		chainId: string
		lang: string
		orderType?: number | null
		showLoader?: boolean
	}) => {
		const isAddressEmpty = !formatted && !lat && !lng
		const urls = await tenantUrls([TenantUrlPickOptions.WebFlowAddressURL], undefined, showLoader)
		let requestUrl = urls.webFlowAddressURL

		if (isAddressEmpty) {
			requestUrl += `&lang=${lang}&type=getBranchesList&cust=openRest&noFilter=true`
		}
		const requestPayload = {
			chainId,
			type: 'getBranchesList',
			addr: isAddressEmpty ? {} : { formatted, lat, lng },
			cust: 'openRest',
			lang,
			orderType,
			noFilter: true,
		}

		return sendRequest(
			showLoader,
			`${requestUrl}&xrs=ewwfa`,
			isAddressEmpty ? 'get' : 'post',
			requestPayload,
			{
				'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
			},
			undefined,
			undefined,
			null,
			false
		)
	},
}
